import Swiper from '../autoload/_swiper';

class GalleryCarouselText {

    doAThing() {
        console.log('animations Do a thing')

    }

    constructor(){

      console.log('GalleryCarousel')

        var swiperClass = '.gallery-swiper-with-text';

        $(swiperClass).each(function ( index ) {

          console.log('GalleryFSCarousel')

            var swiperID = 'gallery-swiper-with-text-' + index;
            var swiperIDHash = '#gallery-swiper-with-text-' + index;

            $(this).attr('id', swiperID);

            var homeSwiper = new Swiper(swiperIDHash, {

                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },

                pagination: {
                    el: '.swiper-pagination-text',
                    clickable: true,
                },
                on: {
                    init() {
                        setTimeout(() => {
                            window.dispatchEvent(new Event('resize'))
                        }, 200)
                    },
                },

            });

            homeSwiper.on('transitionStart', function () {

                //console.log('transitionStart');

            });

        });

    }
}

export default GalleryCarouselText



// WEBPACK FOOTER //
// ./scripts/util/galleryCarouselText.js